import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import Alert from 'react-bootstrap/lib/Alert';
import Button from 'react-bootstrap/lib/Button';

import { toTimezone } from '../../utils/dates';

import './booking-result.css';

const dateTimeFormat = 'D MMMM YYYY H:mm';
const dateTimeFormatTz = 'D MMMM YYYY H:mm UTCZ';

class SuccessScreen extends Component {
  addTimezone(datetime, tz) {
    console.log(tz);
    tz = tz || 'UTC';
    return toTimezone(datetime, tz);
  }

  render() {
    const { t, order, cities, bikeTypes, contactEmail, needsConfirmation } = this.props;

    const city = order && (cities.find(city => city.id === order.city));
    const dropOffCity = order && (cities.find(city => city.id === order.dropOffCity));
    const bikeType = order && (bikeTypes.find(bt => bt.id === order.bikeType));

    let dropOffString;
    if (dropOffCity.id !== city.id) {
      dropOffString = [t('in'), ' ', <span className="highlight">{t(dropOffCity.name, { ns: 'cities' })}</span>];
    }

    const dtFormat = city.timezoneName === dropOffCity.timezoneName ? dateTimeFormat : dateTimeFormatTz;

    const containerClass = [
      'booking-success',
      needsConfirmation ? 'booking-confirmation' : ''
    ].join(' ');

    return (
      <div className={containerClass}>
        {(!needsConfirmation) &&
          <h2>{t('Reservation was successful!')}</h2>
        }

        {(needsConfirmation) &&
          <h2>{t('Booking request was sent to rental company!')}</h2>
        }

        <p>
          {(!needsConfirmation) &&
            <small>
              {t('Booking confirmation with a voucher was sent on your email')}
            </small>
          }

          {(needsConfirmation) &&
            <small>
              {t('You will receive voucher when rental company confirms your booking')}
            </small>
          }
        </p>

        <Alert bsStyle="info">
          <h3>
            {t('Booking number')}:{' '}
            <span className="highlight booking-uid">
              {order.uid}
            </span>
          </h3>

          <p>
            {t('You have booked a')} <span className="highlight">
              {t(bikeType.nameEn, { ns: 'bikeTypes' })}
            </span>{' '}
            {t('in')} <span className="highlight">
              {city && t(city.name, { ns: 'cities' })}
            </span>{' '}
            {t('from')} <span className="highlight">
              {this.addTimezone(order.beginTimeTz, city.timezoneName).format(dtFormat)}
            </span>{' '}
            {t('to')} <span className="highlight">
              {this.addTimezone(order.endTimeTz, dropOffCity.timezoneName).format(dtFormat)}
            </span>{' '}
            {dropOffString}
          </p>
        </Alert>

        <div className="text-left">
          <p>
            {t('If you have any questions, you found a mistake or you want to modify the reservation - please send us an email at')}{' '}
            <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
          </p>
        </div>
      </div>
    );
  }
}

SuccessScreen.propTypes = {
  order: PropTypes.object.isRequired,
  cities: PropTypes.array.isRequired,
  bikeTypes: PropTypes.array.isRequired,
  contactEmail: PropTypes.string.isRequired
};

const FailScreen = ({
  t,
  goBackHandler
}) => (
  <div className="booking-fail">
    <h2>{t('Your payment was refused')},<br />{t('please contact us by email')}</h2>

    {!!goBackHandler && (
      <Button
        bsStyle="primary"
        onClick={goBackHandler}
      >
        {t('Back to order details')}
      </Button>
    )}
  </div>
);

const BookingResultScreen = ({
  success,
  needsConfirmation,
  ...otherProps
}) => {
  if (success || needsConfirmation) {
    return (
      <SuccessScreen
        needsConfirmation={needsConfirmation}
        {...otherProps}
      />
    );
  }

  return (
    <FailScreen {...otherProps} />
  );
};

export default translate(['translation'])(BookingResultScreen);



// WEBPACK FOOTER //
// ./src/widgets/BookingResultScreen/index.js